import React from "react";

const SideMenuLink = (props) => {
  const textClass = props.collapsed ? "hidden" : "inline";
  const containerGap = props.collapsed ? "justify-center" : "gap-3";
  let container =
    `flex items-center ${containerGap} rounded-md px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100`;
  if (props.selected === props.title) {
    container = `flex items-center ${containerGap} rounded-md px-3 py-2 text-sm font-semibold text-slate-900 bg-slate-100`;
  }
  let icon = "";
  if (props.icon !== undefined) {
    icon = <img src={props.icon} alt="" className="h-5 w-5" />;
  }

  if (props.logout !== undefined) {
    return (
      <div
        className={container}
        onClick={() => {
          if (props.onLogOut) {
            props.onLogOut();
          }
          props.onClick(props.title);
        }}
      >
        <span>{icon}</span>
        <span className={textClass}>{props.title}</span>
      </div>
    );
  }

  return (
    <div
      className={container}
      onClick={() => {
        props.onClick(props.title);
      }}
    >
      <span>{icon}</span>
      <span className={textClass}>{props.title}</span>
    </div>
  );
};

export default SideMenuLink;
